import { useEffect, useState } from 'react';

import { Button } from 'antd';
import { AuthUseCaseInterface } from 'application/usecases/AuthUseCase';
import { UserStorageUseCaseInterface } from 'application/usecases/UserStorageUseCase';
import Logo from 'assets/images/LogoIconAndTextHorizontal.svg';
import { VerifyRegisterData } from 'domain/entities/AuthEntity';
import { openErrorNoti, openSuccessNoti } from 'presentation/components/Notification';
import TimerCountDown from 'presentation/components/TimerCountDown';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { setUser } from 'presentation/redux/features/authen/authenSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import getMessage from 'utilities/constants/MESSAGE';
import { OTPComponent } from './components/OTP';


interface props {
    authUseCase: AuthUseCaseInterface;
    userStorage: UserStorageUseCaseInterface;
}

const CU00102Page = ({ authUseCase, userStorage }: props) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const email = searchParams.get('email') || '';
    const [password, setPassword] = useState('');
    const location = useLocation();
    const dispatch = useAppDispatch();
    const [otp, setOtp] = useState('');
    const [errMessage, setErrMessage] = useState('');
    const [showTimer, setShowTimer] = useState(false);

    useEffect(() => {
        const state = location.state as any;
        if (state) {
            setPassword(state.password);
        }
    }, []);

    const onChange = (value: string) => {
        setErrMessage('');
        setOtp(value);
    };

    const submit = async () => {
        try {
            const payload: VerifyRegisterData = {
                email: email,
                code: otp,
                password: password,
            };
            dispatch(startFetching());
            const response = await authUseCase.verifyOtpRegister(payload);
            if (response && response.success) {
                userStorage.setUserInfo(response.data);
                dispatch(setUser(response.data));
                navigate(PRIVATE_ROUTES.PATH + '/' + PRIVATE_ROUTES.SUB.DASHBOARD);
            } else {
                setErrMessage(response.message);
                openErrorNoti();
            }
        } catch (error: any) {
            setErrMessage(error.message);
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    const resentOTP = async () => {
        try {
            dispatch(startFetching());
            setErrMessage('');
            setOtp('');
            const response = await authUseCase.resendOtpRegister(email);
            if (response && response.success) {
                setShowTimer(true);
                openSuccessNoti({ description: getMessage('I0135') });
            } else {
                setErrMessage(response.message);
                openErrorNoti();
            }
        } catch (error: any) {
            setErrMessage(error.message);
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    return (
        <section
            className="width-full-screen center-inside CU-001-04-container"
            style={{
                height: '100vh',
            }}
        >
            <div style={{ width: 343 }}>
                <div
                    className="center-inside center"
                    style={{ borderRadius: 100, backgroundColor: '#fff', width: 160, height: 160 }}
                >
                        <img alt="logo" src={Logo} className='logo'/>
                </div>
                <div
                    className="title"
                    style={{ width: '100%', textAlign: 'center', marginTop: 24, marginBottom: 24 }}
                >
                    アカウント作成
                </div>
                <div className="otp-title" style={{ marginBottom: 16 }}>
                    認証コードを入力してください。
                </div>
                <div className="otp-sub-title" style={{ marginBottom: 16 }}>
                    メールアドレスに認証コードを送りました。
                </div>
                <div style={{ marginBottom: 16 }}>
                    <OTPComponent value={otp} valueLength={6} onChange={onChange} />
                    {errMessage && (
                        <div className="flex mt-[5px]">
                            <div
                                id="otp_help"
                                className="ant-form-item-explain ant-form-item-explain-connected"
                                role="alert"
                            >
                                <div className="ant-form-item-explain-error">{errMessage}</div>
                            </div>
                        </div>
                    )}
                </div>
                <div className="otp-footer">
                    認証コードが届きませんか？
                    <div
                        className={`button-style link-resend ${showTimer ? 'disabled' : ''}`}
                        onClick={showTimer ? undefined : resentOTP}
                    >
                        再送信
                    </div>
                    {showTimer && (
                        <TimerCountDown
                            initialTime={2 * 60}
                            whenDone={() => {
                                setShowTimer(false);
                            }}
                        />
                    )}
                </div>
                <Button
                    className="button-login-text"
                    type="primary"
                    style={{ width: '100%', height: 56, marginTop: 16 }}
                    disabled={(otp.trim() + '')?.length !== 6}
                    onClick={() => submit()}
                >
                    ログイン
                </Button>
            </div>
        </section>
    );
};
export default CU00102Page;
